import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { Observable, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';

import { FormData, FormProviderService, PreventDoubleSubmission } from '@fry/lib/forms';
import { BookingType, BookingTypesStore } from '@fry/booking/lib';

@Injectable()
export class BookingTypeEditForm {
    private formData: FormData;

    constructor(
        private provider: FormProviderService,
        private bookingTypes: BookingTypesStore,
    ) {}

    private _fields = [
      {
        id: 'name',
        title: $localize `Name`,
        initial: '',
        widget: {
            type: 'string',
            autocomplete: 'on'
        },
        validators: [Validators.required]
      },
    ];

    init(bookingType: BookingType): Observable<FormData> {
      return this.provider.getFormDataWith(this._fields, bookingType.doc).pipe(
          tap(formData => this.formData = formData),
      );
  }

  @PreventDoubleSubmission()
  submit(bookingType: BookingType): Observable<BookingType> {
      if (this.formData.invalid) {
          return throwError($localize `Please review the form`);
      }

      // TODO: we need to figure out how we save doc vs orig
      // const value = {...userField.doc, ...this.formData.getValue()};
      // userField.doc = value;
      // Object.assign(userField.doc, this.formData.getValue());
      bookingType.doc = {...bookingType.doc, ...this.formData.getValue()};
      return this.bookingTypes.createOrSave(bookingType);
  }

  get pristine() {
      if (!this.formData) {
          return true;
      }
      return this.formData.pristine;
  }
}
